
import { Component, Inject, Prop, Vue } from "vue-property-decorator";
import Loader from "../components/Loader.vue";
import VueApexCharts from "vue-apexcharts";
import { AnalyticFilter } from "@gsx/common";
import { Container } from "inversify";
import { OrganizationListStore } from "../../stores/organization/OrganizationListStore";
import { AnalyticFavoriteManager } from "../../utils/AnalyticFavoriteManager";
import FavoriteBtn from "../components/FavoriteBtn.vue";
import { AnalyticFiltering } from "./AnalyticFiltering";
import { OrganizationFilterStore } from "../../stores/organization/OrganizationFilterStore";

@Component({ components: { Loader, VueApexCharts, FavoriteBtn } })
export default class OrgsFoundingYear extends Vue {
    @Prop() readonly chartHeight!: string;
    @Prop() readonly analyticFilter?: AnalyticFilter;
    @Inject("container") readonly container!: Container;
    organizationListStore: OrganizationListStore = this.container.get(OrganizationListStore);
    organizationFilterStore: OrganizationFilterStore = this.container.get(OrganizationFilterStore);
    analyticFavoriteManager: AnalyticFavoriteManager = this.container.get(AnalyticFavoriteManager);
    analyticFiltering: AnalyticFiltering = this.container.get(AnalyticFiltering);

    get isFavorite() {
        // @ts-ignore
        return this.analyticFavoriteManager.isFavorite(this.$options._componentTag);
    }

    async toggleFavorite() {
        // @ts-ignore
        await this.analyticFavoriteManager.toggleFavorite(this.$options._componentTag);
    }

    get chartKey() {
        return (
            this.organizationFilterStore.afterYear + "-" + this.organizationFilterStore.beforeYear
        );
    }

    get orgsFoundingYearChart() {
        // let items = [];
        // if (this.analyticFilter) {
        //     items = this.analyticFiltering.filteredItems(this.analyticFilter);
        // } else {
        //     items = this.organizationListStore.filteredItems;
        // }

        // const orgsFoundingYear = items
        //     .filter(
        //         (organization) =>
        //             organization.dateYearFounded &&
        //             organization.dateYearFounded >= 1970 &&
        //             organization.dateYearFounded <= new Date().getFullYear(),
        //     )
        //     .map((organization) => organization.dateYearFounded!)
        //     .reduce((prev: Dict, curr: number) => {
        //         prev[curr] = prev[curr] ? prev[curr] + 1 : 1;
        //         return prev;
        //     }, {});

        const analyticDataFilteredByYear = analyticData.filter(
            (row) =>
                row[0]! >= this.organizationFilterStore.afterYear &&
                (!this.organizationFilterStore.beforeYear ||
                    row[0]! <= this.organizationFilterStore.beforeYear),
        );

        const labels = analyticDataFilteredByYear.map((a) => a[0]);
        const count = analyticDataFilteredByYear.map((a) => a[1]);
        const trend = analyticDataFilteredByYear.map((a) => a[2]);

        return {
            chartOptions: {
                labels: labels,
            },
            series: [
                { name: "Organizations", data: count },
                { name: "Trend", data: trend },
            ],
        };
    }
}

const analyticData = [
    [1941, 6, 9.0],
    [1942, 7, 9.5],
    [1943, 5, 10.0],
    [1944, 10, 10.4],
    [1945, 25, 11.0],
    [1946, 10, 11.5],
    [1947, 16, 12.1],
    [1948, 11, 12.7],
    [1949, 16, 13.4],
    [1950, 12, 14.0],
    [1951, 11, 14.7],
    [1952, 37, 15.5],
    [1953, 18, 16.2],
    [1954, 19, 17.1],
    [1955, 15, 17.9],
    [1956, 25, 18.8],
    [1957, 23, 19.8],
    [1958, 24, 20.8],
    [1959, 16, 21.8],
    [1960, 19, 22.9],
    [1961, 27, 24.0],
    [1962, 24, 25.2],
    [1963, 107, 26.5],
    [1964, 15, 27.8],
    [1965, 21, 29.2],
    [1966, 53, 30.7],
    [1967, 25, 32.3],
    [1968, 39, 33.9],
    [1969, 50, 35.6],
    [1970, 23, 37.4],
    [1971, 38, 39.2],
    [1972, 41, 41.2],
    [1973, 29, 43.3],
    [1974, 57, 45.4],
    [1975, 27, 47.7],
    [1976, 35, 50.1],
    [1977, 40, 52.6],
    [1978, 52, 55.3],
    [1979, 62, 58.1],
    [1980, 57, 61.0],
    [1981, 33, 64.0],
    [1982, 98, 67.3],
    [1983, 57, 70.6],
    [1984, 55, 74.2],
    [1985, 109, 77.9],
    [1986, 59, 81.8],
    [1987, 87, 85.9],
    [1988, 120, 90.2],
    [1989, 98, 94.8],
    [1990, 78, 99.5],
    [1991, 73, 104.5],
    [1992, 90, 109.8],
    [1993, 118, 115.3],
    [1994, 216, 121.1],
    [1995, 117, 127.2],
    [1996, 159, 133.6],
    [1997, 236, 140.3],
    [1998, 156, 147.3],
    [1999, 185, 154.7],
    [2000, 193, 162.5],
    [2001, 218, 170.6],
    [2002, 217, 179.2],
    [2003, 246, 188.2],
    [2004, 240, 197.7],
    [2005, 238, 207.6],
    [2006, 240, 218.0],
    [2007, 202, 229.0],
    [2008, 230, 240.5],
    [2009, 252, 252.5],
    [2010, 308, 265.2],
    [2011, 359, 278.5],
    [2012, 326, 292.5],
    [2013, 392, 307.2],
    [2014, 402, 322.7],
    [2015, 315, 338.9],
    [2016, 345, 355.9],
    [2017, 337, 373.7],
    [2018, 338, 392.5],
    [2019, 328, 412.2],
    [2020, 325, 432.9],
    [2021, 199, 454.7],
    [2022, null, 477.5],
    [2023, null, 501.5],
    [2024, null, 526.7],
    [2025, null, 553.1],
    [2026, null, 580.9],
    [2027, null, 610.1],
];
